module.exports = __webpack_public_path__ + "img/jn-active.45f272e3.png";